import React, { useEffect, useState } from "react";
import "../index.css";
import { useParams } from "react-router-dom";
import { useDisclosure, Flex, Image, Container, Box } from "@chakra-ui/react";
import logo from "../assets/img/fullBlack.webp";
import paid from "../assets/img/paids.webp";
import mpesa from "../assets/img/mpesao.webp";
import jpg from "../assets/img/qw.webp";
import logos from "../assets/img/logo.webp";
import bg from "../assets/img/main-bg.webp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { timer } from "../constants/variables";

import LoadingPage from "../components/LoadingPage";
import {
  titleCase,
  handleInput,
  handleInputPledge,
  handleInputChange1,
  handleInputChange3,
  downloadPdf,
  handleCloseThisModal,
  handleCardClick,
} from "../utils/functions";
import { parseUrlParams } from "../utils/urlUtils";
import { PayPart } from "./Features/PayModal";
import {
  handleGeneratePdf,
  handlePay,
  handlePaySurvey,
  handlePledge,
  handleRecheck,
  pollTransactionByRequestId,
  handleViewStats,
  handleViewStatsBeacon,
} from "../utils/api";
import CollectPage from "./CollectPage";
import FourOFour from "./404";
import Advanced from "./Templates/Advanced";
import Standard from "./Templates/Standard";
import Default from "./Templates/Default";
import { usePaylinkData } from "../hooks/usePaylinkData";

TimeAgo.addLocale(en);

const PageWrapper = () => {
  const { trackCode, urlParams } = useParams();
  const urlParamsValues = parseUrlParams(urlParams);

  let urlAmount = urlParamsValues?.urlAmount;
  let urlOption = urlParamsValues?.urlOption;

  let code = trackCode.toUpperCase();
  const printRef = React.useRef();

  const {
    data,
    load,
    amount,
    setAmount,
    number,
    setNumber,
    phoneLength,
    setPhoneLength,
    name,
    setName,
    image,
    buttone,
    nameOption,
    paymentData,
    payLink,
    subActive,
    saleId,
    subscribeData,
    memberPay,
    defaultOptions,
    urlOptions,
    payAccountDetails,
    selection,
    setSelection,
    type,
    org_id,
    sales_code,
    paylink_id,
    original_date,
    imgUri,
    docImageUrl,
    docTemplate,
    docHexCode,
    docTermsService,
    loadDocs,
    disabled,
    contactId,
    setContactId,
    customerName,
    setCustomerName,
    isRegisteredMember,
    isRegisteredPledgeMember,
    registeredOnly,
    dataSale,
    survey,
    setSurvey,
    reqSurveyId,
    setReqSurveyId,
    pledgeNumber,
    setPledgeNumber,
    pledgeAmount,
    setPledgeAmount,
    triggerSurvey,
    setTriggerSurvey,
    requestId,
    setRequestId,
    pay_account_details,
    isApiAmount
  } = usePaylinkData(trackCode, urlOption, urlAmount, code);

  const [isShare, setIsShare] = useState(false);
  const [copied, setCopied] = useState(false);
  const startTimeRef = React.useRef(Date.now());

  useEffect(() => {
    if (org_id && sales_code && saleId) {
      if (!sessionStorage.getItem(`viewed-${saleId}`)) {
        handleViewStats({
          sale_trx_code: sales_code,
          org_id: org_id,
          sale_id: saleId,
          event_type_opened: 1,
          event_type_paid: 0,
          average_time_on_link: 0,
        });
        sessionStorage.setItem(`viewed-${saleId}`, "true");
      }
    }

    const handleUnload = () => {
      if (org_id && sales_code && saleId && startTimeRef.current) {
        const duration = Math.ceil((Date.now() - startTimeRef.current) / 1000);
        if (duration > 0) {
          handleViewStatsBeacon({
            sale_trx_code: sales_code,
            org_id: org_id,
            sale_id: saleId,
            event_type_opened: 0,
            event_type_paid: 0,
            average_time_on_link: duration,
          });
        }
      }
    };

    // Use visibilitychange as it's more reliable than unload on mobile
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        handleUnload();
        // Reset start time so we don't double count if they come back
        startTimeRef.current = Date.now();
      }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);
    // Keep the cleanup for component unmount (e.g. navigation within SPA)
    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
      handleUnload();
    };
  }, [org_id, sales_code, saleId]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (urlParamsValues?.urlAmount) {
      onOpen();
    }
  }, [urlParamsValues?.urlAmount, onOpen]);

  let [trigger, setTrigger] = useState(false);
  const [opening, setOpening] = useState(false);
  const [recurring, setRecurring] = useState(false);
  const [time, setTime] = useState();
  const [clicked, setClicked] = useState(false);
  const [isToOpen, setIsToOpen] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [paidBy, setPaidBy] = useState("");
  const [phoneNumberBy, setPhoneNumberBy] = useState("");
  const [transactionCode, setTransactionCode] = useState("");
  const [updating, setIsUpdating] = useState(false);
  const [payType, setPayType] = useState("mpesa");
  const [checkoutUrl, setCheckoutUrl] = useState(null);
  const [verify, setVerify] = useState(true);
  const [other_details, setOtherDetails] = useState();
  const [selection_details, setSelectionDetails] = useState();

  const components = {
    advanced: Advanced,
    standard: Standard,
    default: Default,
  };

  const Invoice =
    components[docTemplate?.toLowerCase()] || components["default"];

  setTimeout(() => {
    setTime(0);
  }, 60000);

  const options = {
    autoClose: 500,
  };

  const buttonDisable = (button, selection) => {
    if (button) {
      if (selection) {
        return true;
      } else return false;
    } else return true;
  };


  const handlePayment = async () => {
    setTrigger(true);
    payType === "card" ? setVerify(true) : setVerify(false);

    const result = await handlePay({
      org_id,
      sales_code,
      amount,
      number,
      paymentData,
      name,
      recurring,
      selection,
      type,
      payType,
      saleId,
      other_details: other_details,
      selection_details: selection_details,
      pay_account_details: pay_account_details,
    });

    if (result.success) {
      // Track successful payment attempt (initial)
      // Note: Recheck confirms actual success for non-card, but card might be authorising.
      // Since handlePaymentRecheck is called for non-card, we might track there too.
      // But user asked for "event_type_paid".
      // Let's track here for Card auth URL generation success? Or wait?
      // For MPESA, it says "Kindly check your phone". That's not fully paid yet.
      // Real "PAID" verification happens in handlePaymentRecheck.

      toast.success(result.message);
      if (result.checkoutUrl) {
        setCheckoutUrl(result.checkoutUrl);
        // Card flow - might be paid after redirect
      } else {
        setTimeout(() => {
          toast.info(
            payType === "card"
              ? "Processing checkout..."
              : "Kindly check your phone and pay"
          );
          onClose();
        }, 1000);

        if (type !== "Collection") {
          setTimeout(() => {
            window.location.reload();
          }, Number(timer) + 500);
        }

        if (payType !== "card") {
          handlePaymentRecheck(result.requestId);
        }
      }
    } else {
      toast.warning(result.message);
      setTrigger(false);
    }
  };

  // Poll the payment by its request id until it succeeds, fails or times out
  const pollPaymentByRequestId = async (requestId) => {
    const res = await pollTransactionByRequestId(requestId, amount);
    return res.status === "paid"
      ? { success: true, data: res.data }
      : { success: false };
  };

  const handlePaymentRecheck = async (requestId) => {
    setIsUpdating(true);
    const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

    let result;
    if (typeof requestId === "string" && requestId) {
      result = await pollPaymentByRequestId(requestId);
    } else {
      // No request id (shouldn't happen) - fall back to the phone number lookup
      await sleep(Number(timer) + 5000);
      result = await handleRecheck(org_id, number, amount);
    }

    if (result.success) {
      setPaymentStatus(true);
      setPaidBy(result.data.paidBy);
      setPhoneNumberBy(result.data.phoneNumberBy);
      setTransactionCode(result.data.transactionCode);
      setAmount(result.data.amount);

      // Track confirmed payment
      handleViewStats({
        sale_trx_code: sales_code,
        org_id: org_id,
        sale_id: saleId,
        event_type_opened: 0,
        event_type_paid: 1,
        average_time_on_link: 0,
      });

    } else {
      setPaymentStatus(false);
    }
    setVerify(false);
    setIsToOpen(true);
    setIsUpdating(false);
  };

  const handleRepay = () => {
    setIsToOpen(false);
    setPaymentStatus(false);
    setIsUpdating(false);
    setIsToOpen(false);
    setTrigger(false);
    onOpen();
  };

  const handlePledgeContribution = async () => {
    setTrigger(true);
    const result = await handlePledge({
      org_id,
      sales_code,
      pledgeNumber,
      customerName,
      pledgeAmount,
      selection,
    });

    if (result.success) {
      toast.success(result.message);
      setOpening(false);
      setTimeout(() => {
        window.location.reload();
      }, Number(timer) + 500);
    } else {
      toast.warning(result.message);
    }
    setTrigger(false);
  };

  const handleGeneratePdfDocument = async () => {
    setClicked(true);
    const result = await handleGeneratePdf({
      docTemplate,
      dataSale,
      docTermsService,
      docHexCode,
      docImageUrl,
      data,
      paymentData,
      original_date,
    });

    if (result.success) {
      toast.info("Download started!");
      downloadPdf(result.base64, result.fileName);
    } else {
      toast.warning(result.message || "Download Failed!");
    }
    setClicked(false);
  };

  const handlePaymentSurvey = async (surveyAmount, surveyPayType, surveySelection, surveySelectionDetails) => {
    setTrigger(true);
    const result = await handlePaySurvey({
      org_id,
      sales_code,
      amount: surveyAmount || amount,
      number,
      paymentData,
      name,
      payType: surveyPayType || payType,
      selection: surveySelection || selection,
      selection_details: surveySelectionDetails || selection_details,
      saleId,
    });

    if (result && typeof result === 'object' && result.authorization_url) {
      // Set URL for popup and return signal
      setCheckoutUrl(result.authorization_url);
      return { status: "POPUP", request_id: result.request_id };
    }

    if (result.success) {
      setRequestId(result.requestId);
      toast.success(result.message);
      toast.info("Kindly check your phone and pay");
      return result.requestId;
    } else {
      toast.warning(result.message || "an error occurred!");
      setTrigger(false);
      return null;
    }
  };

  const payProps = (
    <PayPart
      handleInputChange3={handleInputChange3}

      subActive={subActive}
      setAmount={setAmount}
      amount={amount}
      clicked={clicked}
      setClicked={setClicked}
      data={data}
      handleGeneratePdf={handleGeneratePdf}
      handleInputChange1={handleInputChange1}
      handlePay={handlePay}
      isOpen={isOpen}
      number={number}
      onClose={onClose}
      onOpen={onOpen}
      trigger={trigger}
      type={type}
      dataSale={dataSale}
      name={name}
      payLink={payLink}
      phoneLength={phoneLength}
      setPhoneLength={setPhoneLength}
      setNumber={setNumber}
      setName={setName}
    />
  );

  return load ? (
    time === 0 ? (
      <FourOFour />
    ) : (
      <LoadingPage />
    )
  ) : data ? (
    !loadDocs && type && type !== "Collection" && type !== "Wallet" ? (
      <Invoice
        docTemplate={docTemplate}
        type={type}
        dataSale={dataSale}
        docTermsService={docTermsService}
        docImageUrl={docImageUrl}
        original_date={original_date}
        amount={amount}
        phoneLength={phoneLength}
        clicked={clicked}
        setClicked={setClicked}
        setAmount={setAmount}
        data={data}
        subActive={subActive}
        handleGeneratePdfDocument={handleGeneratePdfDocument}
        handlePayment={handlePayment}
        isOpen={isOpen}
        name={name}
        number={number}
        onClose={onClose}
        onOpen={onOpen}
        trigger={trigger}
        payLink={payLink}
        docHexCode={docHexCode}
        paymentData={paymentData}
        logo={logo}
        paid={paid}
        bg={bg}
        payPart={payProps}
      />
    ) : (
      <Flex
        minH="100vh"
        maxW="100%"
        overflow="auto"
        boxSizing="border-box"
        justifyContent="center"
        alignItems={type && (type === "Collection" || type === "Wallet") ? "flex-start" : "center"}
        bg={type && (type === "Collection" || type === "Wallet") ? "gray.50" : "white"}
      >
        <Container
          maxW={type && (type === "Collection" || type === "Wallet") ? "md" : "container.lg"}
          p={0}
        >
          <ToastContainer zIndex="10001" />
          <Box
            w="100%"
            ref={printRef}
            position={
              type && (type === "Collection" || type === "Wallet")
                ? "relative"
                : ""
            }
            id="contentToPrint"
            px={type && (type === "Collection" || type === "Wallet") ? 0 : { base: 4, md: 8 }}
            py={type && (type === "Collection" || type === "Wallet") ? 0 : 8}
          >
            {type && (type === "Collection" || type === "Wallet") && (
              <Image
                src={jpg}
                position="fixed"
                top="0"
                left="0"
                width="100%"
                height="100%"
                zIndex="-100"
                objectFit="cover"
                opacity=".05"
              />
            )}

            {type && (type === "Collection" || type === "Wallet") && (
              <CollectPage
                dataSale={dataSale}
                jpg={jpg}
                logos={logos}
                setIsShare={setIsShare}
                isShare={isShare}
                data={data}
                type={type}
                mpesa={mpesa}
                number={number}
                handleInput={handleInput}
                nameOption={nameOption}
                phoneLength={phoneLength}
                disabled={disabled}
                setName={setName}
                setRecurring={setRecurring}
                recurring={recurring}
                setCustomerName={setCustomerName}
                setSelection={setSelection}
                amount={amount}
                opening={opening}
                subActive={subActive}
                payLink={payLink}
                customerName={customerName}
                isRegisteredMember={isRegisteredMember}
                isRegisteredPledgeMember={isRegisteredPledgeMember}
                registeredOnly={registeredOnly}
                buttonDisable={buttonDisable}
                buttone={buttone}
                selection={selection}
                setPledgeAmount={setPledgeAmount}
                pledgeAmount={pledgeAmount}
                handlePledgeContribution={handlePledgeContribution}
                pledgeNumber={pledgeNumber}
                isToOpen={isToOpen}
                handleCloseThisModal={handleCloseThisModal}
                setIsToOpen={setIsToOpen}
                updating={updating}
                paymentStatus={paymentStatus}
                titleCase={titleCase}
                paidBy={paidBy}
                phoneNumberBy={phoneNumberBy}
                transactionCode={transactionCode}
                handleCardClick={handleCardClick}
                handlePaymentRecheck={handlePaymentRecheck}
                handleRepay={handleRepay}
                onOpen={onOpen}
                trigger={trigger}
                name={name}
                isOpen={isOpen}
                trackCode={trackCode}
                original_date={original_date}
                onClose={onClose}
                imgUri={imgUri}
                setAmount={setAmount}
                handlePayment={handlePayment}
                setOpening={setOpening}
                handleInputPledge={handleInputPledge}
                setPhoneLength={setPhoneLength}
                setPledgeNumber={setPledgeNumber}
                setNumber={setNumber}
                urlOption={urlParamsValues?.urlOption}
                urlAmount={urlParamsValues?.urlAmount}
                urlPhone={urlParamsValues?.urlPhone}
                urlOptions={urlOptions}
                defaultOptions={defaultOptions}
                setPayType={setPayType}
                payType={payType}
                checkoutUrl={checkoutUrl}
                setCheckoutUrl={setCheckoutUrl}
                setVerify={setVerify}
                verify={verify}
                paymentData={paymentData}
                downloadPdf={downloadPdf}
                toast={toast}
                setOtherDetails={setOtherDetails}
                setSelectionDetails={setSelectionDetails}
                saleId={saleId}
                memberPay={memberPay}
                subscribeData={subscribeData}
                sales_code={sales_code}
                org_id={org_id}
                survey={survey}
                setSurvey={setSurvey}
                reqSurveyId={reqSurveyId}
                setReqSurveyId={setReqSurveyId}
                contactId={contactId}
                triggerSurvey={triggerSurvey}
                setTriggerSurvey={setTriggerSurvey}
                requestId={requestId}
                setRequestId={setRequestId}
                handlePaymentSurvey={handlePaymentSurvey}
                isApiAmount={isApiAmount}
                selection_details={selection_details}
              />
            )}
          </Box>
        </Container>
      </Flex>
    )
  ) : (
    <LoadingPage />
  );
};

export default PageWrapper;
